
<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title" *ngIf="inner_DeviceBehfaFilterGroup.id==0">Add Filter Group </h5>
    <h5 class="card-title" *ngIf="inner_DeviceBehfaFilterGroup.id>0">Edit Filter Group '{{inner_DeviceBehfaFilterGroup.title}}' </h5>
    <form [formGroup]="DeviceBehfaFilterGroupForm">

      <input type="hidden" formControlName="id" />

      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> Title </label>
          <input formControlName="title" type="text" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_title().valid && get_Form_title().touched" class="form-text text-muted MyErrorRedColor">Enter the title.</small>
        </div>
      </div>

      <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
      <button *ngIf="!InProccessing" type="button"  (click)="OnSubmit()" [disabled]="!DeviceBehfaFilterGroupForm.valid" class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Save </button>
      <button (click)="onBack()" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back </button>
    </form>




  </div>
</div>
